import { gql } from '@apollo/client';

export const CREATE_QUESTIONNAIRE_RESPONSE = gql`
  mutation createQuestionnaireResponse ($input: questionnaire_create_responseInput!) {
  createQuestionnaireResponse(input:$input) {
    message
    success
  }
}`;